import { EIR_POSTCODE } from './features';

export const FONTS = {
  arial: 'Arial',
  helvetica: 'Helvetica',
  sansSerif: 'sans-serif',
};
export const BASE_FONTS = `${FONTS.helvetica}, ${FONTS.arial}, ${FONTS.sansSerif}`;
export const CASE_TYPES = {
  capitalize: 'capitalize',
  lowerCase: 'lowercase',
  upperCase: 'uppercase',
};

export const DEAL_CAROUSEL_SETTINGS = {
  arrows: true,
  dots: false,
  infinite: false,
  lazyLoad: true,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    },
  ],

  slidesToScroll: 2,

  slidesToShow: 2,
  // true doesn't work
  speed: 500,
};

export const GIFT_CONFIG = {
  giftBoxCarouselPageSize: 20,
};
export const CYF_DEAL_TYPE = 'INTERNATIONAL_TRAVEL';

export const DEAL_FOCUS_ENTRIES = [
  150, 250, 250, 500, 500, 500, 750, 750, 750, 1_000, 1_000, 1_000, 1_250,
  1_250, 1_500, 1_500,
];

export const DEFAULT_MAIN_DEAL_IMG_WIDTH = '727';
export const DEFAULT_MAIN_DEAL_IMG_HEIGHT = '487';

export const DEALS_CONFIG = {
  DEFAULT_DEAL_BUSINESS_IMG_HEIGHT: '73',
  DEFAULT_DEAL_BUSINESS_IMG_WIDTH: '161',
  DEFAULT_DEAL_IMG_HEIGHT: '487',
  DEFAULT_DEAL_IMG_HEIGHT_MOBILE: '358',
  DEFAULT_DEAL_IMG_HEIGHT_MOBILE_LG: '385',
  DEFAULT_DEAL_IMG_HEIGHT_SECONDARY: '487',
  DEFAULT_DEAL_IMG_HEIGHT_THUMB: '43',
  DEFAULT_DEAL_IMG_HEIGHT_TWO_BY_TWO: '487',
  DEFAULT_DEAL_IMG_WIDTH: '727',
  DEFAULT_DEAL_IMG_WIDTH_MOBILE: '535',
  DEFAULT_DEAL_IMG_WIDTH_MOBILE_LG: '575',
  DEFAULT_DEAL_IMG_WIDTH_SECONDARY: '727',
  DEFAULT_DEAL_IMG_WIDTH_THUMB: '54',
  DEFAULT_DEAL_IMG_WIDTH_TWO_BY_TWO: '727',
  DEFAULT_MAIN_DEAL_IMG_HEIGHT: '487',
  DEFAULT_MAIN_DEAL_IMG_WIDTH: '727',
  DEFAULT_MEDIUM_DEAL_IMG_HEIGHT: '487',
  DEFAULT_MEDIUM_DEAL_IMG_WIDTH: '727',
  DEFAULT_TOTAL_GUIDE_DEALS: 100, // defaultTotalGuideDeals
  DESKTOP_TILE_IMG_HEIGHT: '220',
  DESKTOP_TILE_IMG_WIDTH: '264',
  MAX_CATEGORY_DEALS_BLOCK: 9,
  MAX_LIMITED_AVAILABILITY: 50,
  MAX_LOGOS_IN_LIST: 3,
  MAX_LOGOS_PERCENTAGE: 100,
  MAX_MEDIUM_DEALS_PER_ROW: 3,
  MAX_SECONDARY_DEALS_BLOCK: 3,
  MAX_SECONDARY_SMALL_DEALS_BLOCK: 2,
  MAX_SUBTITLE_DEAL_CAT_MAIN_SIZE: 120,
  MAX_TEXT_DEAL_MEDIUM_SIZE: 70,
  MAX_TEXT_DEAL_SIZE: 195,
  MAX_TITLE_DEAL_CAT_MAIN_SIZE: 45,
  MAX_TITLE_DEAL_SIZE: 65,
  MOBILE_TILE_IMG_HEIGHT: '110',
  MOBILE_TILE_IMG_WIDTH: '132',
  NUMBER_OF_DEALS: 9,
  OFFSET_CATEGORY_PAGE: 2, // number of deals next to the main deal on the category page
  OFFSET_DEAL_PAGE: 5,
  RECENTLY_VIEWED_DEALS: 4,
  SECONDARY_DEALS_ON_CATEGORY_PAGE: 2,
  SECONDARY_DEALS_ON_DEAL_PAGE: 5,
  SHOW_CARROUSEL_ARROWS: true, // show arrows in the carrousel component
  TRAVEL_DEAL_IMG_HEIGHT_THUMB: '82',
  TRAVEL_DEAL_IMG_WIDTH_THUMB: '120',
};

export const REVIEWS_CONFIG = {
  MIN_REVIEW_AVERAGE: 3.5,
  REVIEWS_PER_PAGE: 10,
  REVIEWS_TO_SHOW: 3,
};

// MAP VIEW
export const MAP_VIEW_CONFIG = {
  MAP_API_DEBOUNCE_TIMEOUT: 750,
  MAP_API_ERROR_TEXT: 'Sorry there was a problem',
  MAP_API_SLOW_TIME: 2_000,
  MAP_DEALS_DEFAULT: 200,
  MAP_DEALS_DEFAULT_MOBILE: 80,
  MAP_DRAG_BEFORE_UPDATE: 80,
  MAP_LAT_LON_DP: 3, // p,
  MAP_MAX_CAROUSEL: 200,
  MAP_MAX_CAROUSEL_MOBILE: 100,
  MAP_ZOOM_DEFAULT: 10,
  MAP_ZOOM_FIRST_LOAD_DEFAULT: 11,
  MAP_ZOOM_LEVEL_DEALS: {
    6: 200,
    6.5: 200,
    7: 200,
    7.5: 200,
    8: 200,
    8.5: 200,
    9: 200,
    9.5: 200,
    10: 200,
    10.5: 200,
    11: 200,
    11.5: 200,
    12: 150,
    12.5: 150,
    13: 150,
    13.5: 150,
    14: 80,
    14.5: 80,
    15: 80,
    15.5: 80,
    16: 80,
  },
  MAP_ZOOM_LEVEL_DEALS_MOBILE: {
    6: 100,
    6.5: 100,
    7: 100,
    7.5: 100,
    8: 100,
    8.5: 100,
    9: 100,
    9.5: 100,
    10: 80,
    10.5: 80,
    11: 80,
    11.5: 80,
    12: 40,
    12.5: 40,
    13: 40,
    13.5: 40,
    14: 40,
    14.5: 40,
    15: 40,
    15.5: 40,
    16: 40,
  },
  MAP_ZOOM_MAX: 16,
  MAP_ZOOM_MIN: 6,
  MAP_ZOOM_SNAP_DEFAULT: 1,
};

export const COOKIES_CONFIG = {
  COOKIE_SUBSCRIBED_EXPIRES: 365,
  COOKIES_EXPIRES_DAY: 1,
  COOKIES_EXPIRES_HALF_YEAR: 182,
  COOKIES_EXPIRES_MONTH: 30,
  COOKIES_EXPIRES_WEEK: 7,
};

// Axios setup
export const AXIOS_RESPONSE_TIMEOUT = 20_000;
export const AXIOS_CONNECT_TIMEOUT = 20_000;

export const SPLUNK_TOKEN = {
  dev: '14e6fcee-7c05-4f29-b02a-2f86ceb27728',
  nxt: '14e6fcee-7c05-4f29-b02a-2f86ceb27728',
  prod: '57c95d85-09e3-4fa9-9ddd-3c1fe5241fd2',
};

export const REACT_CAROUSEL_CONFIG = {
  intervalTime: 9_000,
  transitionTime: 100,
  transitionTimeTravel: 0,
};

export const SPLAT_CONFIG = {
  SPLAT_MAX_WIDTH_PX: 48,
};
export const PAGE_CONFIG = {
  CACHE_AGE: 1_200,
  DESKTOP_NUMBER_OF_PAGES: 1,
  GUIDE_PAGE_SIZE: 30,
  SEARCH_PAGE_SIZE: 12,
};
export const NOT_FOUND_CONFIG = {
  MAIN_DEAL_NOT_FOUND: 500,
};
export const SOCIAL_CONFIG = {
  EMAIL: {
    SHARE_HANDLE: 'fivepm_email_SHARE_SHARE_',
    WEB_ADDRESS: '5pm.co.uk',
  },
  FACEBOOK: {
    FACEBOOK_ID: {
      dev: '1119130994873669',
      nxt: '1374538939489353',
      prod: '396501950453618',
    },
    SHARE_HANDLE: 'fivepm_social_SCM00003_SHARE_',
  },
  GOOGLE: {
    GOOGLE_ID: {
      dev: '684553407213-b04gffuovqs6pfvjirr0r0j4jckcsq8k.apps.googleusercontent.com',
      nxt: '684553407213-b04gffuovqs6pfvjirr0r0j4jckcsq8k.apps.googleusercontent.com',
      prod: '684553407213-b04gffuovqs6pfvjirr0r0j4jckcsq8k.apps.googleusercontent.com',
    },
  },
  TWITTER: {
    HANDLE_NAME: '@5pm',
    SHARE_HANDLE: 'fivepm_social_SCM00004_SHARE_',
  },
  WHATSAPP: {
    SHARE_HANDLE: 'fivepm_social_SCM00005_SHARE_',
    WEB_ADDRESS: '5pm.co.uk',
  },
};

// Refer A Friend Social ITO
export const FACEBOOK_RAF_ITO = 'raf_facebook';
export const WHATSAPP_RAF_ITO = 'raf_whatsapp';
export const TWITTER_RAF_ITO = 'raf_twitter';
export const EMAIL_RAF_ITO = 'raf_email';

export const isCountryGB = process.env.NEXT_PUBLIC_COUNTRY_CODE === 'gb';

export const REDIRECT_LOCATION = 'https://www.5pm.co.uk/deals/glasgow';

export const getDesktopPageSize = () => {
  return DEALS_CONFIG.NUMBER_OF_DEALS * PAGE_CONFIG.DESKTOP_NUMBER_OF_PAGES;
};
export const getTotalDealsOnFirstCategoryPage = () => {
  return 2 + getDesktopPageSize();
};

export const getTotalDealsOnFirstDealPage = () => {
  return 5 + getDesktopPageSize();
};

// my account changes

export const CLUB_WOWCHER_LEVELS = {
  Bronze: 'bronze',
  Gold: 'gold',
  Pink: 'pink',
  Platinum: 'platinum',
  Silver: 'silver',
};

export const API_CONFIG = {
  BRAND_HEADER: 'wowcher',
  BRAND_HYPHEN_DOMAIN: 'wowcher',
  SUB_BRAND: '5pm',
};

export const LOCALE = 'en-GB'; // this is en-IE on ireland sites
export const BRAND_HYPHEN_DOMAIN = 'fivepm';
export const FRONTEND_LOGS = 'frontend logs';
export const DISPLAY_NAME = 'wowcher';
export const MERCHANT_NAME = 'Wowcher';

export const DEFAULT_LOCATION = {
  _score: 'NaN',
  brand: 'wowcher',
  countryCode: 'gb',
  description: null,
  domain: null,
  id: 277_173,
  latLon: { lat: 55.833_332_061_767_58, lon: -4.25 },
  name: 'Glasgow',
  region: 'Scotland',
  shortName: 'glasgow',
  siteGroup: null,
  status: null,
};

// Navigation Rows
export const noOfRowsInEachGrid = (navCat) => {
  // Manage rows as per requirement
  switch (navCat) {
    case 'Garden':
      return [4, 6];

    case 'Spa Days':
      return [3, 2];

    case 'Home':
      return [6, 4, 5, 16];

    case 'Gifts':
      return [2, 5];

    default:
      return [4, 4];
  }
};

export const BRANDSWAP_KEY = '6cb7a73fe2b44e75b669e8d9fdc1af46';
export const PREFERENCE_CENTRE_DEFAULT_LOCATIONS = [
  '5pm_aberdeen',
  '5pm_edinburgh',
  '5pm_glasgow',
  '5pm_national_deal',
  '5pm_travel',
];

export const CUSTOMER_DEFAULT_TOKEN = 'th1515adumMyt0k3n'; // recent deals storage key

export const UNBXD_KEYS = {
  dev: 'https://libraries.unbxdapi.com/sdk-clients/ss-unbxd-dev-wowcher-en47171696834830/ua-staging/ua.js',
  nxt: 'https://libraries.unbxdapi.com/sdk-clients/ss-unbxd-stage-wowcher-en47171696834966/ua-staging/ua.js',
  prod: 'https://libraries.unbxdapi.com/sdk-clients/ss-unbxd-prod-wowcher-en47171696835046/ua/ua.js',
};

export const GIFTFINDER_CONFIG = {
  dev: 'https://s3.eu-west-1.amazonaws.com/static10.devwowcher.co.uk/binaries/gift-finder-wow_v1.json',
  nxt: 'https://s3.eu-west-1.amazonaws.com/static01.nxtwowcher.co.uk/binaries/gift-finder-wow_v1.json',
  prod: 'https://s3.eu-west-1.amazonaws.com/static.wowcher.co.uk/binaries/gift-finder-wow_v1.json',
};

export const CLOUDFLARE_TRACE = 'https://www.cloudflare.com/cdn-cgi/trace';

export const brandRedemptionFieldMap = 'redemptionInstructionsOthersPdf'; // // Mapping of brand names to their corresponding redemption instruction field names.
// This allows the app to dynamically select the correct PDF field based on the active brand.

export const CURRENCY_CONFIG = {
  code: 'GBP',
  symbol: '£',
};

export const VIP_CONFIG = {
  MAX_VIP_COST: 4.99,
  VIP_LIMIT: 60,
  VIP_SUBSCRIPTION_DEAL_ID: 18_927_099, // for ie site the number is 20_543_436 -- also called as VIP number in code
};

export const AWIN_ADVERTISER_ID = 108_580;

export const DEFAULT_SEARCH_SUGGESTIONS = [
  'spa',
  'bed',
  'mattress',
  'spa day',
  'city break',
  'afternoon tea',
  'holiday',
  'hotel',
  'london',
  'massage',
  'laptop',
  'sofa',
];

export const PAGE_SIZE_CONFIG = {
  FIND_FEED: 20,
  VOUCHER_FEED: 10,
};

export const PAYMENT_TIMEOUT = 40_000;

export const ALLOW_SCRIPT_TAGS_CONFIG = {
  ADD_TAGS: ['script'],
  FORCE_BODY: true,
};

export const CAROUSEL_TIME_INTERVALS = {
  INTERVAL_TIME: 9_000,
  TRANSITION_TIME: 100,
  TRANSITION_TIME_TRAVEL: 0,
};

export const FIND_PAGE_CONFIG = {
  DESKTOP_HEIGHT: '384',
  DESKTOP_WIDTH: '573',
  MOBILE_HEIGHT: '275',
  MOBILE_WIDTH: '412',
};

// claim credit update status
export const CLAIM_CREDIT_UPDATE_STATUS = 'ON_DEMAND_REFUND';
// Checkout delivery option types
export const STANDARD_DELIVERY_OPTION_TYPE = 1;
export const CLICK_AND_COLLECT_DELIVERY_OPTION_TYPE = 41;
export const VIP_SUBSCRIPTION_DEAL_ID = 18_927_099;

// We show 9 deals per page so let's make the request based on this number
export const NUMBER_OF_DEALS = 9; // changed to dealsConfig: {numberOfDeals: 9,}
export const DESKTOP_NUMBER_OF_PAGES = 1; // changed to pageConfig: {desktopNumberOfPages: 1,}
export const DESKTOP_PAGE_SIZE = NUMBER_OF_DEALS * DESKTOP_NUMBER_OF_PAGES; // changed to created a helper function for this : getDesktopPageSize inside config.js
export const SEARCH_PAGE_SIZE = 12; // changed to pageConfig: {searchPageSize: 12,}
export const GUIDE_PAGE_SIZE = 30; // changed to pageConfig: {guidePageSize: 12,}
export const DEFAULT_TOTAL_GUIDE_DEALS = 100; // changed to dealsConfig: {defaultTotalGuideDeals: 100,}
// filters
export const FILTER_CATEGORY = 'category';
export const FILTER_ALL = 'all';
export const FILTER_MAXPRICE = 'maxPrice';
export const FILTER_MINPRICE = 'minPrice';
export const FILTER_SORTBY = 'orderBy';
export const FILTER_SUBCATEGORY = 'subcategory';
export const filterPrice = [
  {
    name: '0',
    value: '0',
  },
  {
    name: '10',
    value: '10',
  },
  {
    name: '20',
    value: '20',
  },
  {
    name: '50',
    value: '50',
  },
  {
    name: '100',
    value: '100',
  },
  {
    name: '1000',
    value: '1000',
  },
];
// possible values: POPULARITY, DATE, PRICE, POSITION, DISCOUNTPERCENTAGE, RECENTLYADDED, DISTANCE
export const filterPopularity = [
  {
    name: 'Popularity',
    value: 'popularity',
  },
  {
    name: 'Price high to low',
    value: 'price',
  },
  /*
  {
    name: 'Date',
    value: 'date',
  },
  */
  {
    name: 'Discount %',
    value: 'discountPercentage',
  },
  {
    name: 'Recently Added',
    value: 'recentlyAdded',
  },
  {
    name: 'Price low to high',
    value: 'pricelow',
  },
];
export const filterPriceTravel = [
  {
    name: '0',
    value: '0',
  },
  {
    name: '50',
    value: '50',
  },
  {
    name: '100',
    value: '100',
  },
  {
    name: '150',
    value: '150',
  },
  {
    name: '200',
    value: '200',
  },
  {
    name: '300',
    value: '300',
  },
  {
    name: '400',
    value: '400',
  },
  {
    name: '500',
    value: '500',
  },
  {
    name: '750',
    value: '750',
  },
  {
    name: '1000',
    value: '1000',
  },
];

export const displayGiftingOptionCheckout = (price = '') => {
  return {
    'e-gift': 'Send As E-Gift',
    // gift: 'Gift',
    // 'gift-pack': 'Add Gift-Pack',
    // 'ndd-gpk': `Gift Pack - Next Day Delivery${
    // price ? ` - ${CURRENCY_SYMBOL}${price}` : ''
    // }`,
    none: 'None',
    // 'std-gpk': `Gift Pack - Standard Delivery${
    //   price ? ` - ${CURRENCY_SYMBOL}${price}` : ''
    // }`,
    // wrapped: 'Send Gift Wrapped',
  };
};

// Forms
export const TYPE_PAYMENT = 'TYPE_PAYMENT';
export const TYPE_PAYMENT_UNDERLINED = 'TYPE_PAYMENT_UNDERLINED';
export const TYPE_UNDERLINED = 'TYPE_UNDERLINED';

export const editProfileFormConfig = [
  { id: 'profile_name', inputLabel: 'First Name', inputName: 'firstName' },
  { id: 'profile_surname', inputLabel: 'Surname', inputName: 'lastName' },
  { id: 'profile_email', inputLabel: 'Email', inputName: 'email' },
  {
    id: 'profile_addr1',
    inputLabel: 'Address Line 1',
    inputName: 'addressLine1',
  },
  {
    id: 'profile_addr2',
    inputLabel: 'Address Line 2',
    inputName: 'addressLine2',
  },
  { id: 'profile_tow_city', inputLabel: 'Town/City', inputName: 'town' },
  {
    id: 'profile_postcode',
    inputLabel: `${EIR_POSTCODE ? 'eircode' : 'Postcode'}`,
    inputName: 'postcode',
  },
];

export const updatePasswordFormConfig = [
  {
    id: 'passwordOld',
    inputLabel: 'Current password',
    inputName: 'oldPassword',
  },
  { id: 'passwordNew', inputLabel: 'New password', inputName: 'newPassword' },
  {
    id: 'passwordConfirm',
    inputLabel: 'Confirm new password',
    inputName: 'confirmNewPassword',
  },
];
export const PRIVACY_EMAIL = 'privacy@5pm.co.uk';
export const BRAND_NAME = '5pm';
export const SITE_NAME = '5pm';
